// extracted by mini-css-extract-plugin
export default {"icon_add":"consulta_icon_add__wHcaB","div_header_consulta":"consulta_div_header_consulta__mDWpb"};